import { render, staticRenderFns } from "./PublicationsSearch.vue?vue&type=template&id=6f719d03&"
import script from "./PublicationsSearch.vue?vue&type=script&lang=js&"
export * from "./PublicationsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports